module.exports = __webpack_public_path__ + "img/report-sample-14@3x.e0074a74.png";